module.exports = __webpack_public_path__ + "media/images/about-us/Net-Promoter-Score-4f9e38fcd885a8ee992df7183e42e295.svg";